<template>
    <div @click.stop v-if="opened">
        <div class="fixed z:$(comment-overlay-zindex) w:full h:full bg:#0000001A top:0 left:0"></div>
        <div class="fixed z:$(comment-zindex) w:full h:full flex jc:flex-end top:0 left:0 {pt:36}@<sm">
            <div class="w:full max-w:414 h:full flex flex-direction:column bg:white rel {max-w:none;rt:20}@<sm">
                <div class="flex ai:center jc:space-between p:24|24">
                    <span class="f:20 font:bold">
                        留言
                        <span class="ml:4" v-if="opened === 1">({{ count }})</span>
                        <i class="fa-regular fa-comment" v-else></i>
                    </span>
                    <button class="inline-flex w:24 h:24 ai:center jc:center" @click="hide" type="button">
                        <span class="bg:url('image/icon_close_login.svg') w:20 h:20 inline-block"></span>
                    </button>
                </div>
                <div class="bb:1|solid|#EBEBEB"></div>
                <div class="rel flex:1 overflow-y:auto" id="comment-panel" v-if="opened === 1">
                    <div class="rel" :key="item.id" v-for="(item, idx) in list" :id="`comment-${item.id}`">
                        <div class="mx:24 bb:1|solid|#EBEBEB" v-if="idx"></div>
                        <div class="py:24 px:24 {bg:#EDF5FF}.active" :class="{ active: item.id === latest }">
                            <comment-row @delete="openDeleteModal(item)" :item="item" @reply="openInput(item)" @report="openReportModal(item)" @toggle="toggleReply(item)"></comment-row>
                        </div>
                        <template v-if="item.toggle">
                            <div class="pb:24">
                                <div :key="sub.id" v-for="sub in item.list" :id="`comment-${sub.id}`">
                                    <div class="px:24 {bg:#EDF5FF}.active" :class="{ active: sub.id === latest }">
                                        <div class="py:20 ml:8 pl:24 border-left:2|solid|#F8F8F8">
                                            <comment-row @delete="openDeleteModal(sub)" :item="sub" :parent="item" @reply="openInput(sub, item)" @report="openReportModal(sub)"></comment-row>
                                        </div>
                                    </div>
                                </div>
                                <div class="color:#A9A9A9 px:24 f:14 ml:32 cursor:pointer" @click="more(item.list)" v-if="item.list.length < item.reply_count">
                                    載入更多留言...
                                </div>
                            </div>
                        </template>
                    </div>
                    <div class="color:#A9A9A9 pb:24 px:24 f:14 mt:0! {d:none}::after cursor:pointer" @click="more(list)" v-if="list?.length < count">
                        載入更多留言...
                    </div>
                </div>
                <div class="flex ai:center flex:1 bg:url(image/comment-mask.png) bg:bottom bg:cover" v-else>
                    <div class="px:67 text:center">
                        <div class="font-weight:600 f:20 lh:32px color:gray01 mb:32">
                            請先<span class="color:#538BD4">登入 OPT歐趴糖</span>，即可觀看留言並加入討論！
                        </div>
                        <a class="
                            w:174.52 h:49 border:0 bg:url(image/index/bg_btn.svg) background-size:100%|100% inline-flex jc:center ai:center color:white box-shadow:0|9|12|0|#1877F24D r:100 f:18 font-weight:700 lh:25px letter-spacing:1
                            ~transform|ease|300ms
                            {transform:scale(1.1)}:hover
                        " :href="login_url">
                            <span>登入 / 註冊</span>
                        </a>
                    </div>
                </div>
                <div class="
                    flex ai:center p:24 gap:8
                    border-top:1|solid|#EBEBEB
                    {flex-direction:column;ai:stretch;gap:12}.actived
                    {flex}.actived_.username>div:nth-child(2)
                    {flex}.actived_.buttons
                    {block}.actived_.attachments
                " :class="{ actived: focus }" v-if="opened === 1">
                    <comment-post-field @cancel="closeInput" @chuser="usernameModal.show()" fixed @focus="focus = true" ref="field" :to="replyTo" @update="send"></comment-post-field>
                </div>
            </div>
        </div>
    </div>
    <comment-delete-modal ref="deleteModal" @confirm="deleteComment"></comment-delete-modal>
    <comment-report-modal ref="reportModal" @submit="informComment"></comment-report-modal>
    <comment-username-modal ref="usernameModal" @submit="changeNicknameType"></comment-username-modal>
</template>

<script setup>
    const global = useGlobal();
    const userInfo = useUserInfo();

    const props = defineProps({
        id: { required: true, type: Number },
        login_url: { type: String },
        modal: { default: false, type: Boolean }
    });

    const count = ref(0);
    const field = ref();
    const focus = ref(false);
    const latest = ref();
    const list = ref();
    const opened = ref(0);
    const replyTo = ref();

    let target = null;

    const deleteModal = ref()
    const reportModal = ref();
    const usernameModal = ref()

    const changeNicknameType = (type) => {
        userInfo.type = type;
    };

    const closeInput = () => {
        focus.value = false;
        replyTo.value = null;
    };

    const deleteComment = () => {
        api("api/comment/remove", { id: target.id }).done((res) => {
            if (res.success) {
                target.status = 3;
                global.error("留言已刪除");
            }
        });
    };

    const hide = () => {
        opened.value = 0;
    };

    const informComment = (data) => {
        data.comment_id = target.id;

        api("api/comment/inform", data).done((res) => {
            if (res.success) {
                global.success("已成功送出");
                reportModal.value.hide();
            }
        });
    };

    const more = (list, reply) => {
        const last = list[list.length - 1];
        const data = { post_id: last.post_id };

        if (last.parent_id) {
            data.parent_id = last.parent_id;
            data.asc = 1;
            data.after = last.id;
            data.size = reply ? 0 : 5;
        } else {
            data.before = last.id;
        }

        api("api/comment/list", data).done((res) => {
            if (res.success) {
                res.list.forEach((item) => {
                    list.push(item);
                });

                if (reply) {
                    send(reply);
                }
            }
        });
    };

    const openDeleteModal = (item) => {
        target = item;
        deleteModal.value.show();
    }

    const openInput = (item, parent) => {
        item.parent = parent;
        replyTo.value = item;
        field.value.focus();
    }

    const openReportModal = (item) => {
        target = item;
        reportModal.value.show();
    }

    const send = (data) => {
        if (replyTo.value) {
            const parent = replyTo.value.parent || replyTo.value;

            if (parent.reply_count != parent.list?.length) {
                if (parent.list) {
                    more(parent.list, data);
                } else {
                    toggleReply(parent, data);
                }
                return;
            }
        }

        data.post_id = props.id;
        data.nickname_type = userInfo.type;

        if (replyTo.value) {
            data.parent_id = replyTo.value.parent_id || replyTo.value.id;
            data.target_id = replyTo.value.id;
        }

        api("api/comment/add", data).done((res) => {
            if (res.success) {
                latest.value = res.data.id;

                if (replyTo.value) {
                    const parent = replyTo.value.parent || replyTo.value;

                    if (!parent.list) {
                        parent.list = [];
                    }

                    if (parent.reply_count === parent.list.length) {
                        parent.list.push(res.data);
                        parent.toggle = true;
                    }

                    parent.reply_count += 1;
                } else {
                    if (!list.value) {
                        list.value = [];
                    }

                    count.value += 1;
                    list.value.unshift(res.data);
                }

                closeInput();

                setTimeout(() => {
                    const panel = $("#comment-panel");
                    let offset = 0;

                    if (res.data.parent_id) {
                        const content = $(`#comment-${res.data.id}`);

                        if (!content.length) {
                            return;
                        }

                        const container = $(`#comment-${res.data.parent_id}`);

                        offset = container.parent().scrollTop() + container.position().top + content.position().top; //置頂
                        offset -= (panel.height() - content.height()) / 2; //置中
                    }

                    panel.animate({ scrollTop: offset }, 300);
                });
            }
        });
    };

    const show = async () => {
        if (await userInfo.init()) {
            if (list.value) {
                opened.value = 1;
            } else {
                api("api/comment/list", { post_id: props.id }).done((res) => {
                    if (res.success) {
                        count.value = res.count;
                        list.value = res.list;
                        opened.value = 1;
                    }
                });
            }
        } else {
            opened.value = 2;
        }
    };

    const toggleReply = (item, reply) => {
        if (item.list) {
            item.toggle = !item.toggle;
        } else {
            api("api/comment/list", { post_id: item.post_id, parent_id: item.id, asc: 1, size: reply ? 0 : 5 }).done((res) => {
                if (res.success) {
                    item.reply_count = res.count;
                    item.list = res.list;
                    item.toggle = !item.toggle;

                    if (reply) {
                        send(reply);
                    }
                }
            });
        }
    };

    defineExpose({ hide, show });

    watch(() => props.id, () => {
        list.value = null;
    });

    if (props.modal) {
        watch(opened, () => $("body").toggleClass("lock-scroll"));
    }
</script>
